import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const metricsFeatureKey = 'metrics'

export interface MetricsRedux {
  sessionExtTxDataAvailableTimes?: { [sessionId: string]: number }
  sessionStartTimes?: { [sessionId: string]: number }
  sessionCwTxDataAvailableTimes?: { [sessionId: string]: number }
  sessionPositionDataAvailableTimes?: { [sessionId: string]: number }
}

export const metricsInitialState: MetricsRedux = {
  sessionExtTxDataAvailableTimes: {},
  sessionStartTimes: {},
  sessionCwTxDataAvailableTimes: {},
  sessionPositionDataAvailableTimes: {},
}

export const metricsSlice = createSlice({
  name: metricsFeatureKey,
  initialState: metricsInitialState,
  reducers: {
    storeSessionExtTxDataAvailableTime: (
      oldState,
      action: PayloadAction<{
        sessionId: string
        extTxDataAvailableTime: number
      }>,
    ) => {
      if (!oldState.sessionExtTxDataAvailableTimes) {
        oldState.sessionExtTxDataAvailableTimes = {}
      }
      oldState.sessionExtTxDataAvailableTimes[action.payload.sessionId] =
        action.payload.extTxDataAvailableTime
    },

    clearSessionExtTxDataAvailableTime: (
      oldState,
      action: PayloadAction<{ sessionId: string }>,
    ) => {
      if (oldState.sessionExtTxDataAvailableTimes) {
        const filteredEntries = Object.entries(
          oldState.sessionExtTxDataAvailableTimes,
        ).filter(([sessionId]) => sessionId !== action.payload.sessionId)
        oldState.sessionExtTxDataAvailableTimes =
          Object.fromEntries(filteredEntries)
      }
    },
    storeSessionStartTime: (
      oldState,
      action: PayloadAction<{ sessionId: string; startTime: number }>,
    ) => {
      if (!oldState.sessionStartTimes) {
        oldState.sessionStartTimes = {}
      }
      oldState.sessionStartTimes[action.payload.sessionId] =
        action.payload.startTime
    },
    clearSessionStartTime: (
      oldState,
      action: PayloadAction<{ sessionId: string }>,
    ) => {
      if (oldState.sessionStartTimes) {
        const filteredEntries = Object.entries(
          oldState.sessionStartTimes,
        ).filter(([sessionId]) => sessionId !== action.payload.sessionId)
        oldState.sessionStartTimes = Object.fromEntries(filteredEntries)
      }
    },
    storeSessionCwTxDataAvailableTime: (
      oldState,
      action: PayloadAction<{
        sessionId: string
        cwTxDataAvailableTime: number
      }>,
    ) => {
      if (!oldState.sessionCwTxDataAvailableTimes) {
        oldState.sessionCwTxDataAvailableTimes = {}
      }
      oldState.sessionCwTxDataAvailableTimes[action.payload.sessionId] =
        action.payload.cwTxDataAvailableTime
    },
    clearSessionCwTxDataAvailableTime: (
      oldState,
      action: PayloadAction<{ sessionId: string }>,
    ) => {
      if (oldState.sessionCwTxDataAvailableTimes) {
        const filteredEntries = Object.entries(
          oldState.sessionCwTxDataAvailableTimes,
        ).filter(([sessionId]) => sessionId !== action.payload.sessionId)
        oldState.sessionCwTxDataAvailableTimes =
          Object.fromEntries(filteredEntries)
      }
    },
    storeSessionPositionDataAvailableTime: (
      oldState,
      action: PayloadAction<{
        sessionId: string
        positionDataAvailableTime: number
      }>,
    ) => {
      if (!oldState.sessionPositionDataAvailableTimes) {
        oldState.sessionPositionDataAvailableTimes = {}
      }
      oldState.sessionPositionDataAvailableTimes[action.payload.sessionId] =
        action.payload.positionDataAvailableTime
    },
    clearSessionPositionDataAvailableTime: (
      oldState,
      action: PayloadAction<{ sessionId: string }>,
    ) => {
      if (oldState.sessionPositionDataAvailableTimes) {
        const filteredEntries = Object.entries(
          oldState.sessionPositionDataAvailableTimes,
        ).filter(([sessionId]) => sessionId !== action.payload.sessionId)
        oldState.sessionPositionDataAvailableTimes =
          Object.fromEntries(filteredEntries)
      }
    },
  },
})

export const {
  storeSessionExtTxDataAvailableTime,
  clearSessionExtTxDataAvailableTime,
  storeSessionStartTime,
  clearSessionStartTime,
  storeSessionPositionDataAvailableTime,
  clearSessionPositionDataAvailableTime,
  storeSessionCwTxDataAvailableTime,
  clearSessionCwTxDataAvailableTime,
} = metricsSlice.actions

export default metricsSlice.reducer
